import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Grid,
    Card,
    CardContent,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Stack,
    Button,
    FormHelperText,
    Typography,
    Toolbar,
    AppBar
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { updateEndorsementFormData, updateEndorsementScreenNumber } from 'src/features/rfqDataSlice';
import { useDispatch } from 'react-redux';
import request from '../../utils/request';
import SumInsuredPreview from './sections/SumInsuredPreview';
import CustomerDetailsView from './sections/CustomerDetails/CustomerDetailsView';
import DynamicFormView from './sections/DynamicForms/DynamicFormView';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import CustomerChangesTable from './EndorsementView/sections/CustomerChangesTable';
import DynamicFormChanges from './EndorsementView/sections/DynamicFormChanges';
import SumInsuredChanges from './EndorsementView/sections/SumInsuredChanges';
import ClausesCoverageChanges from './EndorsementView/sections/ClausesCoverageChanges';
import HypothecationChangeDetails from './EndorsementView/sections/HypothecationChangeDetails';
import RiskDescriptionSection from './EndorsementView/sections/RiskDescriptionSection';
import SuggestedDeductibleSection from './EndorsementView/sections/SuggestedDeductibleSection';
import WarrantiesExclusionsChanges from './EndorsementView/sections/WarrantiesExclusionsChanges';
import PolicyEndDateSection from './EndorsementView/sections/PolicyEndDateSection';
import PolicyCancellationSection from './EndorsementView/sections/PolicyCancellationSection';



const QcComparisonDialog = ({ onClose, endorsementData, setShowSnackBarAlert }) => {
    const dispatch = useDispatch();
    const [policyDetailsData, setPolicyDetailData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            id: endorsementData?.id,
            qcStatus: '',
            remarks: ''
        },
        validationSchema: Yup.object({
            qcStatus: Yup.string().required('QC status is required'),
            remarks: Yup.string().required('Remark is required')
        }),
        onSubmit: (values) => {
            const URL = 'endorsement/qcApproval';
            setLoading(true)
            request({
                url: URL,
                method: 'POST',
                data: values
            })
                .then((response: any) => {
                    setLoading(false);

                    setShowSnackBarAlert({
                        status: true,
                        type: response.status ? 'success' : 'error',
                        message: response['message']
                    });

                    onClose();

                })
                .catch((err) => {
                    setShowSnackBarAlert({
                        status: true,
                        type: 'error',
                        message: err.message
                    });
                    setLoading(false);
                });
        }
    });
    useEffect(() => {
        getPolicyDetailData();
        dispatch(updateEndorsementScreenNumber(3))
    }, [])
    useEffect(() => {
        dispatch(updateEndorsementFormData({
            ...endorsementData['endorsementData']
        }));
    }, [endorsementData])

    if (!endorsementData) return null;

    const {
        dynamicFormData = [],
        secondDynamicFormData = [],
        thirdDynamicFormData = [],
        customerData,
        sumInsuredSectionData,
    } = endorsementData['endorsementData'];

    const endorsementChanges = endorsementData?.endorsementChangeData || {};

    const showCustomerData = endorsementData?.type === 'Non-Financial' || endorsementData?.type === 'Both';

    const getPolicyDetailData = () => {
        request({
            url: 'insurancePolicy/getPolicyById',
            method: 'post',
            data: {
                policyId: endorsementData?.policyId

            }
        }).then(
            (response) => {
                setPolicyDetailData(response['data']);
            },
            (error) => {
                console.log(error);
            }
        );
    }
    return (
        <Dialog fullScreen open={true} onClose={onClose}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                        sx={{ marginLeft: 1 }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ flex: 1 }} variant="h6" component="div">
                        Comparison
                    </Typography>

                </Toolbar>
            </AppBar>


            <DialogContent sx={{ p: 0 }}>
                <Box display="flex" height="100%">
                    {/* Left half - PDF in iframe */}
                    <Box width="50%" height="100%">
                        <iframe
                            src={endorsementData?.endorsementDocument}
                            title="PDF Preview"
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                        />
                    </Box>

                    {/* Right half - Endorsement Preview */}
                    <Box width="50%" height="100%" overflow="auto" p={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardContent>
                                        <form onSubmit={formik.handleSubmit}>
                                            { customerData && (
                                                <CustomerChangesTable
                                                    changes={endorsementChanges?.customerData}
                                                />
                                            )}

                                            {dynamicFormData?.length > 0 && (
                                                <DynamicFormChanges
                                                    forms={endorsementChanges?.dynamicFormData}
                                                />
                                            )}

                                            {secondDynamicFormData?.length > 0 && (
                                                <DynamicFormChanges
                                                    forms={endorsementChanges?.secondDynamicFormData}
                                                />
                                            )}

                                            {thirdDynamicFormData?.length > 0 && (
                                                <DynamicFormChanges
                                                    forms={endorsementChanges?.thirdDynamicFormData}
                                                />
                                            )}

                                            {
                                            // (endorsementData?.type === 'Financial' || endorsementData?.type === 'Both') &&
                                                sumInsuredSectionData &&
                                                Object.keys(sumInsuredSectionData).length > 0 && (
                                                    <SumInsuredChanges
                                                        sumInsuredChanges={
                                                            endorsementChanges?.sumInsuredData?.changes
                                                        }
                                                        excelChanges={endorsementData?.endorsementData?.sumInsuredSectionData}
                                                    />
                                                )}


                                            <RiskDescriptionSection data={endorsementChanges} />
                                            <ClausesCoverageChanges data={endorsementChanges} />
                                            <HypothecationChangeDetails data={endorsementChanges?.hypothetical_details} />
                                            <SuggestedDeductibleSection data={endorsementChanges} />
                                            <PolicyEndDateSection data={endorsementChanges} />
                                            <PolicyCancellationSection data={endorsementChanges}/>
                                            <WarrantiesExclusionsChanges data={endorsementChanges} />

                                            <Box mt="auto">
                                                <FormControl fullWidth margin="normal" size="small" error={formik.touched.qcStatus && Boolean(formik.errors.qcStatus)}>
                                                    <InputLabel id="qc-status-label">QC Status <Typography component="span" sx={{ color: 'red' }}>
                                                        *
                                                    </Typography></InputLabel>
                                                    <Select
                                                        size="small"
                                                        labelId="qc-status-label"
                                                        id="qcStatus"
                                                        name="qcStatus"
                                                        value={formik.values.qcStatus}
                                                        label={
                                                            <React.Fragment>
                                                                QC Status{' '}
                                                                <Typography component="span" sx={{ color: 'red' }}>
                                                                    *
                                                                </Typography>
                                                            </React.Fragment>
                                                        }

                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    >
                                                        <MenuItem value="QC Approved">QC Approved</MenuItem>
                                                        <MenuItem value="QC Rejected">QC Rejected</MenuItem>
                                                        <MenuItem value="QC Revised">QC Revised</MenuItem>
                                                    </Select>
                                                    <FormHelperText>
                                                        {formik.touched.qcStatus && formik.errors.qcStatus}
                                                    </FormHelperText>
                                                </FormControl>

                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    minRows={3}
                                                    id="remarks"
                                                    name="remarks"
                                                    label={
                                                        <React.Fragment>
                                                            Remark{' '}
                                                            <Typography component="span" sx={{ color: 'red' }}>
                                                                *
                                                            </Typography>
                                                        </React.Fragment>
                                                    }

                                                    value={formik.values.remarks}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                                                    helperText={formik.touched.remarks && formik.errors.remarks}
                                                    margin="normal"
                                                />

                                                <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
                                                    <Button variant="contained" color="error" onClick={onClose}>
                                                        Cancel
                                                    </Button>
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        loading={loading}
                                                    >
                                                        Submit
                                                    </LoadingButton>
                                                </Stack>
                                            </Box>
                                        </form>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default QcComparisonDialog;
